<template>
	<div>
		<v-dialog v-model="dialog_add_bom" no-click-animation persistent fullscreen content-class="full-height" scrollable transition="dialog-bottom-transition">
	      <v-card flat>
            <v-toolbar flat noshadow :height="56">
                <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
                <v-toolbar-title>Add Raw Material</v-toolbar-title>
            </v-toolbar>
	        
			<v-card-text dialog-card-content>
				<v-form data-vv-scope="form" full-width>
	            <v-layout wrap>
	            		<v-flex xs12 sm12 md12 form-item @click="$parent.fn_openProducts('Android', 'Products', 'ref_bomObjProduct')">
			               <v-text-field  
			               		v-model="$parent.Form.bomObj.productName" 
			               		label="Name" 
			               		placeholder=" " 
			               		append-icon="arrow_drop_down"
			               		ref="ref_bomObjProduct" 
			               		:onUpdate="$parent.fn_updateBomProduct" 
			               		v-validate="'required'" 
			               		:error-messages="errors.collect('form.name')"  
			               		data-vv-name="name"
			               		required>
			               	</v-text-field>
			            </v-flex>

                        <v-flex xs6 sm6 md6 pl-3>
                            <v-text-field
                                id="bom_qty"
                                label="Quantity"
                                placeholder=" "
                                v-model="$parent.Form.bomObj.qty"
                                data-vv-name="quantity" 
                                v-validate="'required|decimal:3'" 
                                :error-messages="errors.collect('form.quantity')"   
                                type="number"
                                required
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs6 sm6 md6 pl-3>
                            <v-text-field
                                reaonly
                                :disabled="true"
                                label="Unit"
                                placeholder=" "
                                :value="$parent.Form.bomObj.unitName"
                                required
                            ></v-text-field>
                        </v-flex>

	            </v-layout>

				</v-form>

	        </v-card-text>

			<v-card-actions class="pa-0">
	          <!-- <v-spacer></v-spacer> -->
	          <!-- <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog">close</v-btn> -->
	          <!-- <v-btn color="blue darken-1" flat @click.native="$parent.fn_saveRawMaterialItem">Done</v-btn> -->
                <v-layout row wrap style="background:#ddd;">
                    <v-flex xs6 sm6 md6>
                        <v-btn style="height:48px !important" nomargin block no-round-borders noshadow @click="fn_checkValidation('new')">Done &amp; New</v-btn>
                    </v-flex>
                    <v-flex xs6 sm6 md6>
                        <v-btn style="height:48px !important" color="primary" nomargin block no-round-borders noshadow @click="fn_checkValidation(null)">Done</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
export default{
	data(){	
		return{
			dialog_add_bom: false
		}
	},
	methods:{
		openDialogWeb: function () {	
            if(!this.dialog_add_bom){
                this.dialog_add_bom = true;
                setTimeout(() => {
                    this.$parent.fn_openProducts('Android', 'Products', 'ref_bomObjProduct');
                }, 100);
            }
		},
		closeDialogWeb: function () {
			this.dialog_add_bom = false;
		},
        fn_checkValidation: function(type){
            this.$validator.validateAll('form').then((result) => {
                if(result){
                    this.$parent.fn_saveBomItem(type);
                }
            })
        }
		
	}
}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/product/dialogs/dialog_add_bom.vue